// Purpose: Order API calls
// Caller: ProductOutCreatePage
// Dependencies: utils/xhr
// Main Functions: createOrder
// Side Effects: HTTP POST /order

import { xhr } from 'utils'

export const createOrder = (data) => xhr.post('/order', data)
